import { render, staticRenderFns } from "./ArticleMusic.vue?vue&type=template&id=aea14ad8&scoped=true"
import script from "./ArticleMusic.vue?vue&type=script&lang=js"
export * from "./ArticleMusic.vue?vue&type=script&lang=js"
import style0 from "./ArticleMusic.vue?vue&type=style&index=0&id=aea14ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea14ad8",
  null
  
)

export default component.exports